var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDryCleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_686_26076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_686_26076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.375 21.5V15.6635H5.602C5.01817 15.6635 4.52183 15.4582 4.113 15.0475C3.70433 14.6368 3.5 14.1382 3.5 13.5515C3.5 13.1262 3.61575 12.7333 3.84725 12.373C4.07858 12.0128 4.38525 11.7456 4.76725 11.5712L11.25 8.6905V7.74225C10.6757 7.57692 10.2083 7.25933 9.848 6.7895C9.48783 6.31967 9.30775 5.78725 9.30775 5.19225C9.30775 4.44442 9.56908 3.80875 10.0918 3.28525C10.6143 2.76175 11.2488 2.5 11.9955 2.5C12.742 2.5 13.3765 2.76283 13.899 3.2885C14.4215 3.81417 14.6827 4.44875 14.6827 5.19225H13.1635C13.1635 4.85442 13.052 4.57125 12.829 4.34275C12.606 4.11425 12.3297 4 12 4C11.6622 4 11.379 4.11425 11.1505 4.34275C10.922 4.57125 10.8078 4.85442 10.8078 5.19225C10.8078 5.53008 10.922 5.81325 11.1505 6.04175C11.379 6.27042 11.6622 6.38475 12 6.38475C12.2125 6.38475 12.3906 6.45658 12.5343 6.60025C12.6781 6.74408 12.75 6.92225 12.75 7.13475V8.6905L19.223 11.5712C19.6047 11.7469 19.9129 12.0142 20.1477 12.373C20.3826 12.7318 20.5 13.1236 20.5 13.5483C20.5 14.1341 20.2947 14.6331 19.884 15.0452C19.4735 15.4574 18.975 15.6635 18.3885 15.6635H16.625V21.5H7.375ZM5.602 14.1635H7.375V13.1923H16.625V14.1635H18.3885C18.5628 14.1635 18.7083 14.1026 18.825 13.9808C18.9417 13.8589 19 13.7058 19 13.5213C19 13.3994 18.9696 13.2885 18.9087 13.1885C18.8477 13.0885 18.7563 13.0122 18.6345 12.9595L12 10.0078L5.375 12.9595C5.25317 13.0122 5.16025 13.0885 5.09625 13.1885C5.03208 13.2885 5 13.3994 5 13.5213C5 13.7058 5.05642 13.8589 5.16925 13.9808C5.28208 14.1026 5.42633 14.1635 5.602 14.1635Z",
    fill: "#F46530"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryCleaning);
export default __webpack_public_path__ + "static/media/dry_cleaning.39771c44bd5684d4ccd3f55dcbac31f5.svg";
export { ForwardRef as ReactComponent };